var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { useParams } from 'react-router-dom';
var Provider = /** @class */ (function (_super) {
    __extends(Provider, _super);
    function Provider(props) {
        var _this = _super.call(this, props) || this;
        if (props.store.hidrate()) {
            if (props.debug) {
                console.debug('Provider Debug:', "[".concat(_this.getViewName(), "]"), 'Hidrate');
            }
        }
        props.store.subscribe(function () { return _this.onUpdate(); });
        if (props.debug) {
            console.debug('Provider Debug:', "[".concat(_this.getViewName(), "]"), 'KeepAlive:', props.keepAlive);
            console.debug('Provider Debug:', "[".concat(_this.getViewName(), "]"), 'props:', props.props);
        }
        _this.state = {
            store: props.store,
            context: props.context,
        };
        _this.onMounted();
        _this.onBeforeRender();
        return _this;
    }
    Provider.prototype.componentDidMount = function () {
        this.onAfterRender();
        this.onReceiveProps();
    };
    Provider.prototype.componentDidUpdate = function () {
        this.onReceiveProps();
    };
    Provider.prototype.componentWillUnmount = function () {
        this.onDestroy();
    };
    Provider.prototype.render = function () {
        var Context = this.getContext();
        return _jsx(_Fragment, { children: _jsx(Context.Provider, __assign({ value: this.getState() }, { children: !this.getState().isDestroyed && this.props.children })) });
    };
    Provider.prototype.getContext = function () {
        return this.props.context;
    };
    Provider.prototype.getState = function () {
        var _a;
        return (_a = this.props.store) === null || _a === void 0 ? void 0 : _a.getState();
    };
    Provider.prototype.getViewName = function () {
        var _a;
        return ((_a = this.getStore()) === null || _a === void 0 ? void 0 : _a.viewName) || 'NONE';
    };
    Provider.prototype.getStore = function () {
        var _a;
        return (_a = this.props.store) === null || _a === void 0 ? void 0 : _a.current;
    };
    Provider.prototype.onUpdate = function () {
        if (this.props.debug) {
            console.debug('Provider Debug:', "[".concat(this.getViewName(), "]"), 'onUpdate exec');
        }
        this.forceUpdate();
    };
    Provider.prototype.onMounted = function () {
        var store = this.getStore();
        if (store) {
            if (this.props.debug) {
                console.debug('Provider Debug:', "[".concat(this.getViewName(), "]"), 'onMounted exec', this.props.props);
            }
            if (store && !store.___internal___isMounted) {
                store.___base__mounted && store.___base__mounted(this.props.props || {});
                store.___internal___mounted && store.___internal___mounted(this.props.props || {});
                store.onMounted && store.onMounted(this.props.props || {});
            }
        }
    };
    Provider.prototype.onBeforeRender = function () {
        var store = this.getStore();
        if (store) {
            if (this.props.debug) {
                console.debug('Provider Debug:', "[".concat(this.getViewName(), "]"), 'onBeforeRender exec', this.props.props);
            }
            if ((store === null || store === void 0 ? void 0 : store.___internal___isMounted) && !store.___internal___isBeforeRender) {
                store.___base___beforeRender && store.___base___beforeRender(this.props.props || {});
                store.___internal___beforeRender && store.___internal___beforeRender(this.props.props || {});
                store.onBeforeRender && store.onBeforeRender(this.props.props || {});
            }
        }
    };
    Provider.prototype.onAfterRender = function () {
        var store = this.getStore();
        if (store) {
            if (this.props.debug) {
                console.debug('Provider Debug:', "[".concat(this.getViewName(), "]"), 'onAfterRender exec', this.props.props);
            }
            if ((store === null || store === void 0 ? void 0 : store.___internal___isMounted) && !store.___internal___isAfterRender) {
                store.___base___afterRender && store.___base___afterRender(this.props.props || {});
                store.___internal___afterRender && store.___internal___afterRender(this.props.props || {});
                store.onAfterRender && store.onAfterRender(this.props.props || {});
            }
        }
    };
    Provider.prototype.onReceiveProps = function () {
        var store = this.getStore();
        if (store) {
            if (this.props.debug) {
                console.debug('Provider Debug:', "[".concat(this.getViewName(), "]"), 'onReceiveProps exec', this.props.props);
            }
            if (store === null || store === void 0 ? void 0 : store.___internal___isMounted) {
                store.___internal___receiveProps && store.___internal___receiveProps(this.props.props || {});
                store.onReceiveProps && store.onReceiveProps(this.props.props || {});
            }
        }
    };
    Provider.prototype.onDestroy = function () {
        var store = this.getStore();
        if ((store === null || store === void 0 ? void 0 : store.___internal___isMounted) && !this.props.keepAlive) {
            if (this.props.debug) {
                console.debug('Provider Debug:', "[".concat(this.getViewName(), "]"), 'onDestroy exec');
            }
            store.___base___destroy && store.___base___destroy();
            store.___internal___destroy && store.___internal___destroy();
            store.onDestroy && store.onDestroy(this.props.props || {});
        }
    };
    return Provider;
}(React.Component));
export { Provider };
export function provide(context, store, Component, options) {
    return function (props) {
        var params = useParams();
        return (_jsx(Provider, __assign({ props: __assign(__assign(__assign({ viewName: options === null || options === void 0 ? void 0 : options.viewName }, props), options === null || options === void 0 ? void 0 : options.props), { routerParams: params }), context: context, store: store, keepAlive: options === null || options === void 0 ? void 0 : options.keepAlive, debug: options === null || options === void 0 ? void 0 : options.debug }, { children: _jsx(Component, __assign({}, __assign(__assign({}, props), options === null || options === void 0 ? void 0 : options.props))) })));
    };
}
